module.exports = __webpack_public_path__ + "img/07.eaf9b225.png";